export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/lsa-thumb-864f8be017342bf0a0f4fe7dc01ecf9f.png";